"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

export function EmbedChrome() {
  const [framed, setFramed] = useState<boolean | null>(null);

  useEffect(() => {
    const insideFrame = window.parent !== window;
    setFramed(insideFrame);

    function parentOrigin() {
      try {
        if (document.referrer) return new URL(document.referrer).origin;
      } catch {
        /* A missing referrer falls back to a close signal with no payload. */
      }
      return "*";
    }

    function close() {
      if (window.parent !== window) {
        window.parent.postMessage({ type: "castle-book-close" }, parentOrigin());
      }
    }

    function onKey(event: KeyboardEvent) {
      if (event.key === "Escape") close();
    }

    window.addEventListener("keydown", onKey);

    if (!insideFrame) {
      return () => window.removeEventListener("keydown", onKey);
    }

    function sendSize() {
      const main = document.querySelector("main");
      const height = Math.ceil(main ? main.scrollHeight : document.documentElement.scrollHeight);
      window.parent.postMessage({ type: "castle-book-size", height }, parentOrigin());
    }

    sendSize();
    const observer = new ResizeObserver(sendSize);
    const main = document.querySelector("main");
    if (main) observer.observe(main);
    return () => {
      window.removeEventListener("keydown", onKey);
      observer.disconnect();
    };
  }, []);

  if (framed !== false) return null;

  return (
    <Link href="/" className="nav-link mb-3 inline-flex">
      Back
    </Link>
  );
}
